// Launch promo — single source of truth. Move `PROMO_END_ISO` here to
// change the deadline anywhere in the app.
//
// The date is interpreted in the user's LOCAL time. That is deliberate: a
// customer in Madrid seeing the badge on Sep 30 23:59 shouldn't miss the
// promo because the server is on UTC.

export const PROMO_END_ISO = "2026-09-30T23:59:59";
export const PROMO_DISCOUNT_LABEL = "-30%";
export const PROMO_DATE_LABEL = "30 Sep";

/** Timestamp helper — memoised because Date parsing is not free. */
const _promoEndMs = new Date(PROMO_END_ISO).getTime();

/** True while the promo is still running (now < end). */
export function isPromoActive(now = Date.now()) {
  return now < _promoEndMs;
}

/**
 * Countdown breakdown. Returns `{ d, h, m, s, expired }`.
 * Once `expired` is true, all number fields are 0.
 */
export function getPromoCountdown(now = Date.now()) {
  const diff = _promoEndMs - now;
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0, expired: true };
  const s = Math.floor(diff / 1000) % 60;
  const m = Math.floor(diff / (1000 * 60)) % 60;
  const h = Math.floor(diff / (1000 * 60 * 60)) % 24;
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  return { d, h, m, s, expired: false };
}
